export const renderBooleanAsString = (value: boolean): string =>
  value ? 'Да' : 'Нет';
